<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-snackbar v-model="snackbar_bl_error" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color="orange darken-2">{{ text }}<v-btn color="white" flat @click="snackbar_bl_error = false">X</v-btn></v-snackbar>
        <v-layout wrap justify-space-between xl12>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtsigmno" label="Search By IGM"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtsblno" label="Search By BL"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtscont_no" label="Search By Container"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
            </v-alert>
            <v-alert :value="alerterror" color="error" icon="new_releases">
                <ul>
                    <li v-bind:key="index" v-for="(error, index) in errors">{{ error }}</li>
                </ul>
            </v-alert>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <h3 class="py-4">IGM Details</h3>
                        <export-excel
                            title = "VCFS IGM"
                            :data = "igm_arrival_notices">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="igm_arrival_notices" :search="search"  class="elevation-1"
                    :rows-per-page-items = "[15, 25, 50, 100]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.bl_date }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_description }}</td>
                            <td class="text-xs-right">{{ props.item.line }}</td>
                            <td class="text-xs-right">{{ props.item.line_ref_no }}</td>
                            <td class="text-xs-right">{{ props.item.packages }}</td>
                            <td class="text-xs-right">{{ props.item.package_unit }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_nature }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_type }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_movement }}</td>
                            <td class="text-xs-right">{{ props.item.movement_type }}</td>
                            <td class="text-xs-right">{{ props.item.cont_gross_weight }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="bl_valid" ref="form">
                    <v-layout wrap justify-space-between>
                            <v-flex xs12 md4>
                            </v-flex>
                            <v-flex xs12 md2>
                                <v-text-field v-model="txtsarrival_blno" label="Search By BL" :rules="[(v) => !!v || 'BL is required']"  autofocus required ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md2>
                                <v-btn  color="info" v-on:click="getSArrivalDetails()">Search<v-icon right dark>search</v-icon></v-btn>
                            </v-flex>
                            <v-flex xs12 md4>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    <v-form v-model="valid" ref="form">
                        <v-container fluid v-if="is_bl_searched">
                        <v-layout>
                            <v-flex xs12 md3>
                                <v-menu v-model="dpbl" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="dtbl" label="BL Date" prepend-icon="event" readonly
                                        v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dtbl" @input="dpbl = false"  :rules="[(v) => !!v || 'BL Date is required']"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field v-model="txtline_ref_no" label="Line Ref. No." :rules="[(v) => !!v || 'Line Ref. No. is required']" required ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select v-model="cboline" :items="line_list" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Line is required']"  label="Select Line"></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select v-model="cbopackage_unit" :items="packunit_list" item-value="id"  label="Select Package Unit" :rules="[(v) => !!v || 'Package Unit is required']" item-text="text"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 md3>
                                <v-select v-model="cbocargo_nature" :items="cargo_nature" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Cargo nature is required']"  label="Cargo Nature"></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select v-model="cbocargo_type" :items="cargo_type" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Cargo Type is required']"  label="Cargo Type"></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select v-model="cbocargo_movement" :items="cargo_movement" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Cargo Movement is required']"  label="Cargo Movement"></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select v-model="cbomovement_type" :items="movement_type" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Move. Type is required']"  label="Movement Type"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-card justify-center>
                                <v-card-text primary-title v-for="(arrivaldetails, index) in arrivaldetails_list" v-bind:key="index">
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" arrivaldetails.cont_no" label="Container No." readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field label="Cargo Details" v-model="arrivaldetails.cargo_description"  :rules="[(v) => !!v || 'Cargo Details is required']" ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field label="Cont Gross Weight" v-model="arrivaldetails.cont_gross_weight"  :rules="[(v) => !!v || 'Gross Weight is required']" ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field label="Packages" v-model="arrivaldetails.packages"  :rules="[(v) => !!v || 'Package is required']" ></v-text-field>
                                        </v-flex>
                                        <v-divider v-if="index + 1 < arrivaldetails.length" :key="`divider-${index}`"></v-divider>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-card-text class="mx-auto">
                                <v-container grid-list-xl>
                                    <v-layout wrap justify-space-between>
                                        <v-flex xs12 md4>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                            <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                            <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                    </v-container>
                    </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'importarrival',
    data() {
        return {
            error: false,
            snackbar_bl_error: false,
            y: 'bottom',
            x: 'right',
            mode: '',
            timeout: 5000,
            text: 'BL Details Not Found!',
            bl_valid: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            arrivaldetails_list: [],
            igm_arrival_notices: [],
            is_bl_searched: false,
            conts: [],
            dtbl: new Date().toISOString().substr(0, 10),
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtsarrival_blno: null,
            txtsarrival_mlocode: null,
            txtigmno: null,
            txtsblno: null,
            dpbl: false,
            dpbrethed_on: false,
            cbovessel: null,
            cbosizetype: null,
            txtline_ref_no: null,
            cboline: null,
            cbopackage_unit: null,
            cbocargo_nature: null,
            cbocargo_type: null,
            cbocargo_movement: null,
            cbomovement_type: null,
            txtbondno: null,
            txtblnumber: null,
            cboterminal: null,
            txtstreamer_agent: null,
            txtsigmno: null,
            cont_no: null,
            txtscont_no: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            pagination: {
                page: 1,
                rowsPerPage: 10,
                totalItems: 0
            },
            headers: [
              { text: 'S.No', sorting: false, align: 'left' },
              { text: 'Containet No', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'sizetype' },
              { text: 'IGM', align: 'right', value: 'igm_no' },
              { text: 'IGM Date', align: 'right', value: 'igm_date' },
              { text: 'BL No', align: 'left', value: 'bl_no' },
              { text: 'BL Date', align: 'right', value: 'bl_date' },
              { text: 'Cargo', align: 'right', value: 'cargo_description' },
              { text: 'Line', align: 'right', value: 'line' },
              { text: 'Ref. No', align: 'right', value: 'line_ref_no' },
              { text: 'Package', align: 'right', value: 'packages' },
              { text: 'Unit', align: 'right', value: 'package_unit' },
              { text: 'Cargo Nature', align: 'right', value: 'cargo_nature' },
              { text: 'C Type', align: 'right', value: 'cargo_type' },
              { text: 'C Movement', align: 'right', value: 'cargo_movement' },
              { text: 'Move Type', align: 'right', value: 'movement_type' },
              { text: 'Cont. Gr. Weight', align: 'right', value: 'cont_gross_weight' }
            ],
            cargo_nature: [
                {
                  text: 'Containerized(C)',
                  id: 1
                },
                {
                  text: 'Non-cont.Pack.(P)',
                  id: 2
                },
                {
                  text: 'Liquid Bulk(LB)',
                  id: 3
                },
                {
                  text: 'Dry Bulk(DB)',
                  id: 4
                },
                {
                  text: 'Partconsign.(CP)',
                  id: 5
                }
            ],
            cargo_movement: [
                {
                  text: 'Tranship.Cargo',
                  id: 1
                },
                {
                  text: 'Local Cargo',
                  id: 2
                },
                {
                  text: 'Tranship ICD',
                  id: 3
                }
            ],
            cargo_type: [
                {
                  text: 'Solid',
                  id: 1
                },
                {
                  text: 'General',
                  id: 2
                },
                {
                  text: 'Liquid',
                  id: 3
                },
                {
                  text: 'OIL',
                  id: 4
                },
                {
                  text: 'Powder',
                  id: 5
                },
                {
                  text: 'Perishable',
                  id: 6
                },
                {
                  text: 'Rock',
                  id: 7
                },
                {
                  text: 'Agri',
                  id: 8
                }
            ],
            movement_type: [
                {
                  text: 'By Road',
                  id: 1
                },
                {
                  text: 'From Vessel',
                  id: 2
                },
                {
                  text: 'From Wagon',
                  id: 3
                }
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getVessel(),
        this.getLine(),
        this.getTerminal(),
        this.getSizeType(),
        this.getUnit(),
        this.getLine(),
        this.addConts()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        addConts: function () {
            let checkEmptyLines = this.conts.filter(cont => cont.number === null)

            if (checkEmptyLines.length >= 1 && this.conts.length > 0) return
                this.conts.push({
                    cont_no: null,
                    size_type: null,
                    cargo_description: null,
                    created_by: localStorage.username
                })
        },
        removeLine (contId) {
          if (!this.blockRemoval) this.conts.splice(contId, 1)
        },
        getSArrivalDetails: function () {
            if(this.txtsarrival_blno) {
                this.API_URL = this.$hostname + "/search_arrival_notices?bl_no=" + this.txtsarrival_blno
            } else if (this.txtsarrival_mlocode) {
                this.API_URL = this.$hostname + "/search_arrival_notices?bl_no=" + this.txtsarrival_mlocode
            } else {
                return false
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                if (response.status === 204) {
                    this.snackbar_bl_error = true;
                    return;
                }
                this.arrivaldetails_list = response.data;
                this.is_bl_searched = true;
            },(error) => {
                this.errors = error.response.data.error;
            })
        },
        getData: function () {
            this.loading = true;
            if (this.txtsigmno) {
                this.API_URL = this.$hostname + "/igm_list?igm_no=" + this.txtsigmno
            } else if (this.txtsblno) {
                this.API_URL = this.$hostname + "/igm_list?bl_no=" + this.txtsblno
            } else if (this.txtscont_no) {
                this.API_URL = this.$hostname + "/igm_list?cont_no=" + this.txtscont_no
            } else {
                this.API_URL = this.$hostname + "/igm_list?limit=15"
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.igm_arrival_notices = response.data;
            }, (error) => {
                this.loading = false;
                this.errors = error.response.data.error;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const arrival_data = {
                'blading_date': this.dtbl,
                'line_ref_no': this.txtline_ref_no,
                'line': this.cboline,
                'package_unit': this.cbopackage_unit,
                'cargo_nature': this.cbocargo_nature,
                'cargo_type': this.cbocargo_type,
                'cargo_movement': this.cbocargo_movement,
                'movement_type': this.cbomovement_type
            }
            const data = {'crossDomain': true,
                          'cont_data': this.arrivaldetails_list,
                          'an_data': arrival_data}
            axios.put(this.$hostname + '/search_arrival_notices', data,
                       { headers: {'Authorization': 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    this.alertsmessage = response.data.message;
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.errors = error.response.data.error;
                    window.location.reload();
                })
        },
        getUnit: function () {
            this.API_URL = this.$hostname + "/combos/unit"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.packunit_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        getVessel: function () {
            this.API_URL = this.$hostname + "/combos/vessel"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.vessel_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        getLine: function () {
            this.API_URL = this.$hostname + "/combos/line"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.line_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        getTerminal: function () {
            this.API_URL = this.$hostname + "/combos/terminal"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.terminal_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        getSizeType: function () {
            this.API_URL = this.$hostname + "/combos/sizetype"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.sizetype_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        clearData: function() {
            this.txtigmno = null;
            this.dpbl = null;
            this.dpbrethed_on = null;
            this.cbovessel = null;
            this.cbopackunit = null;
            this.txtvoyageno = null;
            this.cboline = null;
            this.txtbondno = null;
            this.txtblnumber = null;
            this.cboterminal = null;
            this.txtstreamer_agent = null;
            this.txtsigmno = null;
            this.txtsblno = null;
            this.txtsarrival_blno = null;
            this.txtsarrival_mlocode = null;
            this.txtscont_no = null;
            this.cont_no = null;
            this.sealno = null;
            this.cboline = null;
            this.packages = null;
            this.txtline_ref_no = null;
            this.cbopackage_unit = null;
            this.cargo_nature = null;
            this.cargo_type = null;
            this.cargo_movement = null;
            this.movement_type = null;
            this.cont_gross_weigh = null;
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center

</style>
